import React from 'react';
import { Button } from '@mui/material';

export const SubmitButtonForm = ({ children = 'Отправить', ...props }) => {
    return (
        <Button
            color="primary"
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            {...props}
        >
            {children}
        </Button>
    );
};
